import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import About from './pages/About';
import TourPackages from './pages/TourPackages';
import ThingsToDo from './pages/ThingsToDo';
import Bookings from './pages/Bookings';
import ContactUs from './pages/ContactUs';

import WhatsApp from './components/WhatsApp';


import Gallery from './pages/Gallery';
import Events from './pages/Events';
import Japan from './pages/Japan';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen">
        <Routes>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <>
                <SEO
                  title="Sonic Tours Japan - Japan Tourism"
                  description="Explore Japan with Sonic Tours Japan through curated cultural journeys, city escapes, and unforgettable travel experiences in Tokyo, Kyoto, and beyond."
                  keywords="Sonic Tours Japan, Japan Tourism, Japan Travel, Tokyo Tours, Kyoto Tours, Japan Tour Packages"
                  url="https://sonictoursjp.com"
                />
                <Home />
              </>
            }
          />
          <Route
            path="/about-us"
            element={
              <>
                <SEO
                  title="About Us - Sonic Tours Japan"
                  description="Meet Sonic Tours Japan — your trusted local travel partner for personalized Japan tourism experiences and expertly curated journeys."
                  keywords="Sonic Tours Japan, About Sonic Tours Japan, Japan Tour Operator, Tokyo Tours, Japan Travel Agency"
                  url="https://sonictoursjp.com/about-us"
                />
                <About />
              </>
            }
          />

          <Route
            path="/japan"
            element={
              <>
                <SEO
                  title="Japan Tours - Sonic Tours Japan"
                  description="Explore Japan with Sonic Tours Japan through timeless traditions, vibrant cities, and unforgettable journeys."
                  keywords="Japan Tours, Sonic Tours Japan, Japan Travel, Tokyo Kyoto Travel"
                  url="https://sonictoursjp.com/japan"
                />
                <Japan />
              </>
            }
          />

          <Route
            path="/tour"
            element={
              <>
                <SEO
                  title="Tour Packages - Sonic Tours Japan"
                  description="Explore our handpicked Japan tour packages from Sonic Tours Japan — cultural escapes, city adventures, scenic journeys, and more."
                  keywords="Japan Tour Packages, Sonic Tours Japan, Tokyo Tours, Kyoto Tours, Cultural Tours Japan"
                  url="https://sonictoursjp.com/tour"
                />
                <TourPackages />
              </>
            }
          />
          <Route
            path="/gallery"
            element={
              <>
                <SEO
                  title="Gallery - Sonic Tours Japan"
                  description="See beautiful moments from Sonic Tours Japan journeys — Tokyo streets, cultural landmarks, scenic landscapes, and unforgettable travel memories captured."
                  keywords="Japan Photos, Sonic Tours Japan Gallery, Travel Memories, Tokyo Landscapes"
                  url="https://sonictoursjp.com/gallery"
                />
                <Gallery />
              </>
            }
          />
          <Route
            path="/events"
            element={
              <>
                <SEO
                  title="Special Events - Sonic Tours Japan"
                  description="Experience Japan's vibrant festivals and cultural events with Sonic Tours Japan — seasonal celebrations, traditions, and local experiences."
                  keywords="Japan Events, Sonic Tours Japan, Cultural Festivals, Seasonal Experiences"
                  url="https://sonictoursjp.com/events"
                />
                <Events />
              </>
            }
          />
          <Route
            path="/things"
            element={
              <>
                <SEO
                  title="Things to Do - Sonic Tours Japan"
                  description="Discover exciting activities with Sonic Tours Japan — cultural experiences, scenic escapes, culinary journeys, and more."
                  keywords="Things To Do Japan, Sonic Tours Japan, Cultural Experiences, Adventure Activities"
                  url="https://sonictoursjp.com/things"
                />
                <ThingsToDo />
              </>
            }
          />
          <Route
            path="/bookings"
            element={
              <>
                <SEO
                  title="Bookings - Sonic Tours Japan"
                  description="Book your perfect Japan tour easily with Sonic Tours Japan. Custom trips, cultural escapes, and scenic adventures across Japan."
                  keywords="Book Japan Tours, Sonic Tours Japan Bookings, Japan Travel Reservations"
                  url="https://sonictoursjp.com/bookings"
                />
                <Bookings />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <SEO
                  title="Contact Us - Sonic Tours Japan"
                  description="Get in touch with Sonic Tours Japan for bookings, inquiries, or custom tours. Reach us via WhatsApp, email, or phone."
                  keywords="Contact Sonic Tours Japan, Japan Tour Contact, Japan Travel Inquiries"
                  url="https://sonictoursjp.com/contact-us"
                />
                <ContactUs />
              </>
            }
          />

        </Routes>
      </main>

      <WhatsApp />

      <Footer />
    </Router>
  );
};

export default App;